// import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser, NgIf, NgClass } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateHelper } from '@app/_helpers';
import { SiteService } from '@app/_services/site.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-social-share-buttons',
    templateUrl: './social-share-buttons.component.html',
    styleUrls: ['./social-share-buttons.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, NgClass, MatIconModule, TranslateModule]
})
export class SocialShareButtonsComponent implements OnInit {
    constructor(
        // private httpClient: HttpClient,
        private router: Router,
        public translate: TranslateService,
        public translateHelper: TranslateHelper,
        private siteService: SiteService,
        @Inject(PLATFORM_ID) private platformId: any

    ) {
        // var urls = [
        //     "https://platform.twitter.com/widgets.js",
        //     // "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v13.0"
        // ];

        // urls.forEach((url) => {
        //     let jsonpResponse = this.httpClient.jsonp(url, "callback").pipe(
        //         map(() => true),
        //         catchError(() => of(false))
        //     );
        //     jsonpResponse.subscribe();
        // });
    }

    @Input() smallIcons;
    @Input() layout : 'row' | 'col';

    show = true;

    ngOnInit(): void {
        if (!this.siteService.siteSetting.main) {
            this.show = false;
         }
    }

    getUrl(absolute = true): string {
        if (isPlatformBrowser(this.platformId)) {
            return absolute ? window.location.href : this.router.url;
        }
        return "";
    }

    getEncodedUrl(absolute = true): string {
        return encodeURIComponent(this.getUrl(absolute));
    }

    getMessage(encoded = false): string {
        let message = "";

        this.translate.get("check_out_this_item_on_qetaat").subscribe((text) => {
            message = text;
        });

        return encoded ? encodeURIComponent(message) : message;
    }

    getWHatsappMessage(): string {
        let message = this.getMessage() + "\n\n" + this.getUrl();
        return encodeURIComponent(message);
    }
}
